import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ListResource } from '../../../../components/ListResource/ListResource';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useErrorMessage } from '../../../../utils/errorMessage';
import { createInvoiceColumns } from '../../../../utils/createInvoiceColumns';

const ListInvoices = ({ pensioner }) => {
  const { t } = useTranslation();
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();
  const [refreshData, setRefreshData] = useState(false);
  const navigate = useNavigate();

  const columns = createInvoiceColumns({
    t,
    dispatchAPI,
    message,
    setRefreshData,
    refreshData
  });

  return (
    <ListResource
      resourceName="customerinvoices"
      extraQuery={`customer=${pensioner.user._id}&type=SUBSCRIPTION`}
      columns={columns}
      showEdit={false}
      withPageHeader={false}
      withCreateButton={false}
      forceRefresh={refreshData}
      customActionColumn
      onDoubleClickAction={{
        action: (record) => navigate(`/invoices/customers/show/${record?._id}`)
      }}
    />
  );
};

export default ListInvoices;

ListInvoices.propTypes = {
  pensioner: PropTypes.shape({
    user: PropTypes.string
  }).isRequired
};
